export interface TargetingState {
  on_target_list: boolean;
  manually_targeted: boolean;
  manually_excluded: boolean;
  newly_registered: boolean;
  petition_signed?: boolean;
}

/** Derive a human label for why this voter is on (or off) the target list. */
export function targetingSourceLabel(s: TargetingState): string {
  if (s.manually_excluded) {
    return s.on_target_list ? 'Removed by admin (still on Sheet)' : 'Removed by admin';
  }
  if (s.manually_targeted && !s.on_target_list) return 'Added by admin';
  if (s.on_target_list) return 'From Sheet';
  if (s.newly_registered) return 'Newly registered';
  if (s.petition_signed) return 'Signed petition';
  return 'Off list';
}

/** Compute the effective inclusion state for the targeting switch. Petition
 *  signers are on the list (an admin's explicit exclusion still wins). Mirrors
 *  the backend `_apply_audience_filter` rule. */
export function isEffectivelyOnList(s: TargetingState): boolean {
  if (s.manually_excluded) return false;
  return s.on_target_list || s.manually_targeted || s.newly_registered || !!s.petition_signed;
}
